import React, {Component} from 'react';
import style from '../css/lockedAccaBetDetail.css';
import {connect} from 'react-redux';
import {roundNumber} from '../../../helpers/mathFunctions';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {BASE_VALUE} from '../../../constants/chips';
import {getMarketByCode} from "../modules/matchday/helpers/marketHelpers";
import {ASSETS_URL} from "../../../constants/endpoints";
import {TOTAL_GOALS, UNDER_OVER_25} from '../modules/matchday/constants/marketTypes';
import {isWinningBet} from '../modules/matchday/helpers/matchdayHelper';
import {calculateTimeDifference} from '../../../helpers/helperFunctions';

const mapStateToProps = (state, ownProps) => {
    return {selectedOddsType: state.vpp.selectedOddsType, serverTimeOffset: state.vpp.serverTimeOffset};
};

class LockedAccaBetDetail extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isEventDetailsVisible: false,
            selectedOddsType: storeData.vpp.selectedOddsType,
            serverTimeOffset: storeData.vpp.serverTimeOffset
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedOddsType: storeData.vpp.selectedOddsType,
                serverTimeOffset: storeData.vpp.serverTimeOffset
            });
        }
    }

    _createEventDetails(eventDetails) {
        let noGoals = 'No goals';
        return (
            <div>
                <div className={`${style.eventDetailsLine} ${style.even}`}>
                    <div className={style.eventDetailsLineLeft}>{getText('HALF_TIME_RESULT', this.props.store)}</div>
                    <div className={style.eventDetailsLineRight}>{eventDetails.halfTimeResult}</div>
                </div>
            </div>
        );
    }

    render() {
        let systemCurrency = this.props.store != undefined ? this.props.store.getState().vpp.systemCurrency : '';
        let stake = usingNonDecimalCurrency(systemCurrency) ? this.props.bet.Stake : roundNumber(this.props.bet.Stake / BASE_VALUE, 2);
        let stakeUI;

        stakeUI = getFormattedCurrency(this.props.store, stake);

        let bottomContainer;
        let placeHolderUI;
        let returnsUI;
        let outcomeUI;
        let eventDetailsUI;
        let eventDetails;
        eventDetails = (
            <div className={style.eventDetailsWrapper}>
                <div className={style.eventDetails}>
                </div>

            </div>
        )
        let eventDetailsArrow = this.props.isSettledBet && !this.props.voidStatus && eventDetails
            ? (<div>
                </div>
            )
            : null;

        let prizeNumber;
        if (this.props.isSettledBet) {
            prizeNumber = usingNonDecimalCurrency(systemCurrency) ? this.props.bet.Prize : (this.props.prize === undefined ? roundNumber(this.props.bet.Prize / BASE_VALUE, 2) : this.props.prize);
            let outcomeText = prizeNumber > 0 ? getText('WON', this.props.store) : getText('LOST', this.props.store);

            let prize = getFormattedCurrency(this.props.store, prizeNumber);

            returnsUI = (
                <div className={style.returningsContainer}>
                </div>
            );

            outcomeUI = (
                <div
                    className={`${style.outcomeContainer} ${(prizeNumber > 0 && !this.props.voidStatus)
                        ? style.won
                        : ''}`}>{this.props.voidStatus ? getText('VOIDED', this.props.store) : outcomeText}</div>
            );

            placeHolderUI = (<div className={style.placeHolderContainer}></div>);

            eventDetailsUI = (<div className={style.eventDetailsContainer}>
                {this.state.isEventDetailsVisible ? eventDetails : null}
            </div>);
        } else {
            let potentialReturns;
            if (this.props.potentialReturns !== undefined) {
                potentialReturns = usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency) ? Math.round(this.props.potentialReturns) : this.props.potentialReturns;
            } else {
                potentialReturns = getFormattedCurrency(this.props.store, 0);

                if (Number(stake) && Number(this.props.odd)) {
                    potentialReturns = roundNumber(parseFloat(stake) * parseFloat(this.props.odd), 2);

                    if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                        potentialReturns = Math.round(potentialReturns);
                    }

                    potentialReturns = getFormattedCurrency(this.props.store, potentialReturns);
                }
            }

            returnsUI = (
                <div className={style.returningsContainer}>
                    <div className={style.potentialReturnsLabel}>{getText('POT_RETURNS', this.props.store)}</div>
                    <div id={'potential_returns_value_' + this.props.index}
                         className={style.potentialReturnsText}>{potentialReturns.toString()}</div>
                </div>
            );

        }

        let names;
        if (this.props.names && this.props.names.length > 0) {
            names = this.props.names.map((name, index) => {
                return (
                    <div key={index} id={'name_' + this.props.index + '_' + index} className={style.name}>{name}</div>);
            });
        }

        let winLoseStyle = '';
        let winLoseAccaBetSystemType = '';
        let winLoseGameName = '';
        let winLoseAccaEventTime= '';
         let winLoseOddLabel = '';
         let winLoseOdd = '';
        let isWin;
        if (!this.props.isSettledBet && calculateTimeDifference(this.props.bet.EventTime, new Date(Date.now() - this.state.serverTimeOffset)) > 0) {
            isWin = isWinningBet(this.props.bet, this.props.game.goalTimings, this.state.serverTimeOffset);
        }

        if ((this.props.bet.Outcome !== undefined && this.props.bet.Outcome === 'WIN' || isWin) && !this.props.voidStatus) {
            winLoseStyle = style.win;
        } else if ((this.props.bet.Outcome !== undefined && this.props.bet.Outcome === 'LOSE' || isWin === false) && !this.props.voidStatus) {
            winLoseStyle = style.lose;
        }

        if(!this.props.voidStatus && winLoseStyle !== ''){
            winLoseAccaBetSystemType = style.winLoseAccaBetSystemType;
            winLoseGameName = style.winLoseGameName;
            winLoseAccaEventTime = style.winLoseAccaEventTime;
            winLoseOddLabel= style.winLoseOddLabel;
            winLoseOdd = style.winLoseOdd;
        }

        let homeTeam = getText("Matchday_" + this.props.bet.EventDetails.team1, this.props.store);
        let awayTeam = getText("Matchday_" + this.props.bet.EventDetails.team2, this.props.store);

        let betType = getMarketByCode(Number(this.props.bet.Market.Code)).name;
        betType = getText(betType === UNDER_OVER_25.name ? 'UNDER_OVER_2_5' : betType, this.props.store);

        return (
            <div className={`${style.lockedBetContainer} ${winLoseStyle}`}>
                <div className={style.topContainer}>
                    <div className={style.leftContainer}>
                        <div
                            className={`${style.accaBetSystemType} ${winLoseAccaBetSystemType}`}>{betType} : {(this.props.bet.Market.Code === TOTAL_GOALS.code ? `${JSON.parse(this.props.bet.OpaqueData).selection}` : `${getText(JSON.parse(this.props.bet.OpaqueData).selection, this.props.store)}`)}</div>
                        <div 
                            className={` ${style.accaEventTime} ${winLoseAccaEventTime}`}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes}  ${getText('MD', this.props.store, [this.props.leagueDay])} ${this.props.score ? this.props.score : this.props.eventName.gameTitle}`}</div>
                    </div>
                    <div className={style.rightContainer}>
                        <div
                            className={`${style.eventName} ${winLoseGameName}`}>{getText((this.props.game.gameCategory + '_' + this.props.game.name).replace(/\s+/g, '_'), this.props.store)}<img
                            className={style.gameImg}
                            src={`${ASSETS_URL}${this.props.game.assetsPath}/betslipIcon.png`}/></div>
                        <div className={style.oddContainer}>
                            <div className={` ${style.oddLabel} ${winLoseOddLabel}`}>{`${getText('ODDS', this.props.store)}: `}</div>
                            <div className={` ${style.odd} ${winLoseOdd}`}
                                 id={'odd_' + this.props.index}>{this.props.bet.Market.Price}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(LockedAccaBetDetail);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/lockedAccaBetDetail.js